<template>
  <div v-if="data?.name" class="catalog-empty-state-form">
    <BaseImage
      v-if="data?.image_desktop?.meta?.download_url"
      :src="data?.image_desktop?.meta?.download_url"
      :alt="data?.image_desktop?.title || ''"
      loading="eager"
      class="absolute inset-0 -z-10 h-full w-full object-cover object-right md:object-center"
    />
    <div class="absolute inset-0 bg-black opacity-40 w-full h-full -z-[1]" />
    <BaseTitle class="catalog-empty-state-form__title drop-shadow-md" level="h2">
      {{ data.title }}
    </BaseTitle>

    <BaseTitle class="catalog-empty-state-form__subtitle drop-shadow-md" level="h5">
      {{ data.subtitle }}
    </BaseTitle>
    <ContactForm
      :modal-image-src="data?.image_desktop?.meta?.download_url as string || ''"
      :cta-text="data?.cta_button_text"
      :terms-and-cons-url="data?.terms_and_cons_url as string"
      :terms-and-cons-text="data?.terms_and_cons_text as string"
      tracking-event="form_empty_state_submit"
    >
      <template #controls="{ loading }">
        <div class="grid md:grid-cols-2 grid-cols-full gap-8">
          <BaseButton
            type="submit"
            size="xl"
            variant="white"
            class="w-full"
            :disabled="loading"
            :loading="loading"
          >
            {{ data?.cta_button_text }}
          </BaseButton>

          <BaseButton
            type="button"
            size="xl"
            variant="transparent"
            class="w-full text-white"
            @click="emit('retry')"
          >
            {{ t('retry_search') }}
          </BaseButton>
        </div>
      </template>
    </ContactForm>
  </div>
</template>

<script setup lang="ts">
import ContactForm from '~/components/forms/ContactForm.vue';
import { useCmsApi } from '~/composables';
import BaseTitle from '~/components/BaseTitle.vue';
import BaseButton from '~/components/BaseButton.vue';
import BaseImage from '~/components/BaseImage.vue';
import { useI18n } from '#imports';

const { t } = useI18n({
  messages: {
    es: {
      retry_search: 'Reintentar búsqueda',
    },
    en: {
      retry_search: 'Retry search',
    },
  },
});

// eslint-disable-next-line func-call-spacing
const emit = defineEmits<{
  (event: 'retry'): void;
}>();

const { getForm } = useCmsApi();
const data = await getForm('empty_state_form');
</script>

<style scoped>
.catalog-empty-state-form {
  @apply bg-white p-16 relative isolate overflow-hidden rounded-md;
    &__title {
      @apply text-center text-brand-white w-full;
    }
    &__subtitle {
      @apply text-center text-brand-white w-full my-8;
    }
}
</style>
